import React, { Component } from 'react';
import uuid from 'uuid';
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import {setFunction} from '../actions/scActions'

class DropDownFunctions extends Component {

    render () {

        let functions = [{id:'avg',name:'Average'},
            {id:'max',name:'Maximum'},
            {id:'min',name:'Minimum'},
            {id:'sum',name:'Sum'},
            {id:'count',name:'Count'},
            {id:'dev',name:'Deviation'},
            {id:'first',name:'First'},
            {id:'last',name:'Last'}
        ]
        let functionItems;

       functionItems = functions.map(functionItem => {
            return (
                <option key={uuid.v4()} value={functionItem.id}>{functionItem.name}</option>
            )
        });

        return (
            <div className="col-sm-4">
                <label>Functions</label>
                <select className="form-control" value={this.props.sc.functionId} onChange={(event) => this.props.changeFunction(event.target.value)} >
                    {functionItems}
                </select>
            </div>

        )
    }
}

DropDownFunctions.PropTypes = {
    functionID: PropTypes.number,
    changeFunction: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        sc: state.scReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeFunction: (type) => {
            dispatch(setFunction(type))
        }
    }
}

export default connect (mapStateToProps,mapDispatchToProps)(DropDownFunctions)


// WEBPACK FOOTER //
// ./src/containers/DropDownFunctions.js